import { css, keyframes } from "styled-components";
import { media } from "@literati/public-ui-shared-react";

export const deckCardHeight = {
  DEFAULT: "26rem",
  LG: "28.75rem",
} as const;

export const bookShuffleCardSharedStyles = css`
  display: flex;
  border-radius: 20px;
  background-color: white;
`;

export const bookShuffleDeckCardSizeStyles = css`
  height: ${deckCardHeight.DEFAULT};
  width: 18.125rem;
  max-width: 100vw;
  min-width: 300px;

  ${media.lg} {
    height: ${deckCardHeight.LG};
    width: 20.5rem;
  }
`;

export const dialogOverlayStyles = css`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.35);
  z-index: 100;
  overflow: scroll;
`;

export const fadeInOverlayRgba = keyframes`
  from {
    background: rgba(0, 0, 0, 0);
  }
  to {
    background: rgba(0, 0, 0, 0.35);
  }
`;

export const dialogCardHeight = "22rem";
